import React from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MailIcon from "@material-ui/icons/Mail";
import Menu from "./Menu"
import { toogleDrawer } from "../actions/authActions";

import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import HomeRoundedIcon from "@material-ui/icons/HomeRounded";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ContactsRoundedIcon from "@material-ui/icons/ContactsRounded";
import StoreRoundedIcon from "@material-ui/icons/StoreRounded";
import InfoRoundedIcon from "@material-ui/icons/InfoRounded";
import { NavLink } from "react-router-dom";
import { Grid, TextField, Card, Button, Container } from "@material-ui/core";
import { connect } from "react-redux";
import PhoneRoundedIcon from "@material-ui/icons/PhoneRounded";
import Footer from "./Footer";
import ShoppingCartRoundedIcon from "@material-ui/icons/ShoppingCartRounded";
import StarsIcon from "@material-ui/icons/Stars";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
    },
    nav: {
        textDecoration: "none",
        color: "inherit",
    },
    drawer: {
        [theme.breakpoints.up("sm")]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {

    },

    menuButton: {
        marginRight: theme.spacing(2),

    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
}));

function Contact(props) {
    const { window } = props;
    const classes = useStyles();
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawer = (
        <div>
            <div className={classes.toolbar} />
            <Divider />
            <List>
                <NavLink to="/" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <HomeRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Home"} />
                    </ListItem>
                </NavLink>
                <NavLink to="/shop" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <StoreRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Shop"} />
                    </ListItem>
                </NavLink>
                {props.auth.isAuthenticated ? (
                    <NavLink to="/cart" className={classes.nav}>
                        <ListItem button>
                            <ListItemIcon>
                                <ShoppingCartRoundedIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary={"Cart"} />
                        </ListItem>
                    </NavLink>
                ) : null}
                {props.auth.isAuthenticated ? (
                    <NavLink to="/wishlist" className={classes.nav}>
                        <ListItem button>
                            <ListItemIcon>
                                <StarsIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary={"Wishlist"} />
                        </ListItem>
                    </NavLink>
                ) : null}

                <NavLink to="/contact" className={classes.nav}>
                    <ListItem button selected={true}>
                        <ListItemIcon>
                            <ContactsRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Contact Us"} />
                    </ListItem>
                </NavLink>
                <NavLink to="/about" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <InfoRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"About Us"} />
                    </ListItem>
                </NavLink>
            </List>
        </div>
    );

    const container =
        window !== undefined ? () => window().document.body : undefined;

    return (
        <div
        // className={classes.root}
        >
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={
                            () => {
                                props.toogleDrawer()
                            }
                        }
                        className={classes.menuButton}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        variant="h6"
                        align="center"
                        // noWrap
                        style={{
                            fontFamily: " 'Berkshire Swash', cursive",
                            // border: "1px solid",
                            width: "100%",
                        }}
                    >
                        {props.website.website
                            ? props.website.website.header
                            : ""}
                    </Typography>
                </Toolbar>
            </AppBar>
            <Menu />
            <main className={classes.content}>
                <div className={classes.toolbar} />
                <Container maxWidth="md">
                    <Grid
                        container
                        justify="center"
                        alignItems="baseline"
                        spacing={2}
                    >
                        <Grid item xs={12}>
                            <form name="contact" method="post">
                                <input
                                    type="hidden"
                                    name="form-name"
                                    value="contact"
                                />
                                <Grid
                                    container
                                    justify="center"
                                    alignItems="center"
                                >
                                    <Card
                                        style={{ padding: "1rem", width: "100%" }}
                                    >
                                        {" "}
                                        <Typography
                                            style={{ marginBottom: "2rem" }}
                                            align="center"
                                            variant="h3"
                                        >
                                            Contact Us
                                    </Typography>
                                        <Grid
                                            item
                                            xs={12}
                                            style={{ marginBottom: "1rem" }}
                                        >
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                label="Name"
                                                type="text"
                                                name="name"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            style={{ marginBottom: "1rem" }}
                                        >
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                label="Email"
                                                type="email"
                                                name="email"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            style={{ marginBottom: "1rem" }}
                                        >
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                label="Phone Number"
                                                type="number"
                                                name="number"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            style={{ marginBottom: "1rem" }}
                                        >
                                            <TextField
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                fullWidth
                                                label="Message"
                                                type="text"
                                                name="message"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            style={{ marginBottom: "1rem" }}
                                        >
                                            <Button
                                                variant="contained"
                                                fullWidth
                                                color="primary"
                                                type="submit"
                                            >
                                                submit
                                        </Button>
                                        </Grid>
                                    </Card>
                                    <Card
                                        style={{
                                            padding: "1rem",
                                            width: "100%",
                                            marginTop: "1rem",
                                        }}
                                    >
                                        {" "}
                                        <Typography
                                            style={{ marginBottom: "2rem" }}
                                            align="center"
                                            variant="h3"
                                        >
                                            Our Works
                                    </Typography>
                                        <Typography
                                            style={{ padding: "1rem" }}
                                            variant="body1"
                                            align="center"
                                        >
                                            {props.website.website
                                                ? props.website.website.works
                                                : ""}
                                        </Typography>
                                    </Card>
                                </Grid>{" "}
                            </form>
                        </Grid>
                        <Grid item xs={12}>
                            <Card>
                                <Typography
                                    style={{ marginBottom: "2rem" }}
                                    align="center"
                                    variant="h3"
                                >
                                    About Us
                            </Typography>
                                <Grid
                                    container
                                    justify="center"
                                    alignItems="center"
                                >
                                    <Typography
                                        style={{ padding: "1rem" }}
                                        variant="body1"
                                        align="center"
                                    >
                                        {props.website.website
                                            ? props.website.website.description
                                            : ""}
                                    </Typography>
                                </Grid>
                            </Card>

                            <Card style={{ marginTop: "1rem" }}>
                                <Typography
                                    style={{
                                        marginBottom: "2rem",
                                    }}
                                    align="center"
                                    variant="h3"
                                >
                                    Shop Address
                            </Typography>
                                <Grid
                                    container
                                    justify="flex-start"
                                    alignItems="center"
                                >
                                    <Grid item xs={12}>
                                        {" "}
                                        <Typography
                                            style={{ padding: "1rem" }}
                                            variant="body1"
                                            align="left"
                                        >
                                            <StoreRoundedIcon /> &nbsp;
                                        {props.website.website
                                                ? props.website.website.shopAddress
                                                : ""}
                                            {/* {props.website.website.description} */}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography
                                            style={{ padding: "1rem" }}
                                            variant="body1"
                                            align="left"
                                        >
                                            <PhoneRoundedIcon /> &nbsp;
                                        {props.website.website
                                                ? props.website.website.phone1
                                                : ""}
                                            {/* {props.website.website.description} */}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography
                                            style={{ padding: "1rem" }}
                                            variant="body1"
                                            align="left"
                                        >
                                            <PhoneRoundedIcon /> &nbsp;
                                        {props.website.website
                                                ? props.website.website.phone2
                                                : ""}
                                            {/* {props.website.website.description} */}
                                        </Typography>
                                    </Grid>
                                    <Typography
                                        style={{ padding: "1rem" }}
                                        variant="body1"
                                        align="left"
                                    >
                                        <PhoneRoundedIcon /> &nbsp;
                                    {props.website.website
                                            ? props.website.website.phone3
                                            : ""}
                                        {/* {props.website.website.description} */}
                                    </Typography>
                                </Grid>
                            </Card>
                        </Grid>
                    </Grid>

                </Container> </main>
            {/* <Footer /> */}
        </div>
    );
}

const mapStateToProps = (state) => ({
    website: state.website,
    auth: state.auth,
});
export default connect(mapStateToProps, { toogleDrawer })(Contact);
